var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"statistik-user-chart"}},[_vm._l((_vm.items),function(item,index){return [(item.component)?_c('div',{key:index,class:item.raw},[_c(item.component,{tag:"component",attrs:{"sdata":_vm.sdata}})],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }